// removed by extract-text-webpack-plugin
module.exports = {"header":"RecentSearches-header","table":"RecentSearches-table","row":"RecentSearches-row","arrowCell":"RecentSearches-arrowCell","notloggedin":"RecentSearches-notloggedin","placeholder":"RecentSearches-placeholder"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RecentSearches/index.css
// module id = 1743
// module chunks = 0